import { FC } from 'react'
import cn from 'classnames'

interface TabProps {
  title: string
  setTab(tab: string): void
  isActive?: boolean
}

export const Tab: FC<TabProps> = ({ title, isActive, setTab }) => {
  return (
    <h2
      onClick={() => setTab(title)}
      className={cn(
        'text-primary-base xs:max-w-full xs:w-fit max-w-full cursor-pointer text-center text-lg leading-snug whitespace-nowrap',
        {
          'xs:border-b-4 xs:border-b-primary-base font-bold': isActive,
          'xs:pb-2 font-normal': !isActive,
        }
      )}
    >
      {title}
    </h2>
  )
}
